import axios, { AxiosRequestConfig, Method } from 'axios';
import store from './store/index';


const apiClient = axios.create({
  baseURL: '/',
  withCredentials: true
});

export interface ApiRequestOptions {
  method: Method;
  url: string;
  data?: any;
  params?: any;
}

export const apiRequest = async ({ method, url, data, params }: ApiRequestOptions, noCache = true) => {
  const config: AxiosRequestConfig = {
    method,
    url,
    data,
    params
  };
  if (!noCache) {
    config.headers = {
      'Use-cache': 'false'
    };
  }
  try {
    const response = await apiClient.request(config);
    return response.data;
  } catch (error: any) {
    if (error?.response?.status === 401) {
      store.dispatch('alert', { message: 'Usuário sem autorização.', type: 'error' });
      throw error;
    }

    if (error?.response?.data?.message === 'Token expired' || error?.response?.data?.message === 'No token provided') {
      store.dispatch('setAuthenticated', false);
      throw error;
    }

    console.error('API request error:', error);
    throw error;
  }
};
